// LargeScreenBreadcrumbsContainer.tsx
import React from 'react';
import { Box } from '@mui/material';

interface LargeScreenBreadcrumbsContainerProps {
    children: React.ReactNode;
}

export default function LargeScreenBreadcrumbsContainer({
    children,
}: LargeScreenBreadcrumbsContainerProps) {
    return (
        <Box
            sx={{
                width: '100%',
                maxWidth: '1905px',
                mx: 'auto',
                px: '3.5rem',
                paddingTop: '0.125rem',
                paddingBottom: '0.125rem',
            }}
            data-testid="large_screen_breadcrumbs_container"
        >
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                }}
            >
                {children}
            </Box>
        </Box>
    );
}
